import { PropertyAPI } from "./lib/property-api";
import { SavedRow, } from "./types";
import { get_source } from "./lib/source";
export async function ImageCount(property_id: string) : Promise<number|null> {
  const api: PropertyAPI = new PropertyAPI();
  const s: SavedRow|null = await api.get_property_by_source(property_id,get_source());
  if(s && Array.isArray(s.Media)){
    return s.Media.length;
  }
  return null;
}
